export default "__VITE_ASSET__jvSKxxQV__"